export enum DocumentTypesEnum {
  Unknown = 0,
  Journal = 2,
  FlexForm = 3,
  HtmlForm = 4,
  WebForm = 5,
  Document = 6,
  PDFForm = 7,
  Media = 8,
  ExerciseProgram = 10,
  Attachment = 11,
  CNESSTReport = 12,
  Video = 13,
  SimpleLetter = 14,
}
